var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnvelope(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7.124 75.837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.995-55.137H26.71a2.91,2.91,0,0,0,3.154-3.218v-9.374a2.932,2.932,0,0,0-3.229-3.218H12.919a2.905,2.905,0,0,0-3.153,3.218v9.374A2.932,2.932,0,0,0,12.995-55.137Zm6.048-8.078-5.195-5.141H25.781l-5.195,5.141c-.324.313-.529.432-.778.432S19.366-62.9,19.042-63.215Zm-6.75-3.661,3.715,3.661L12.293-59.5Zm11.329,3.661,3.715-3.661V-59.5Zm-3.812,2.657a2.908,2.908,0,0,0,2.106-.983l.173-.162,3.974,3.974h-12.5L17.541-61.7l.162.162A2.944,2.944,0,0,0,19.809-60.558Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.77d8fdaf2bc7d39ffe9f057406c47cc5.svg";
export { ForwardRef as ReactComponent };